import { render, staticRenderFns } from "./IncomingTariff.vue?vue&type=template&id=23f22ec3&"
import script from "./IncomingTariff.vue?vue&type=script&lang=ts&"
export * from "./IncomingTariff.vue?vue&type=script&lang=ts&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports